import { render, staticRenderFns } from "./student-location.vue?vue&type=template&id=3aea9d52"
import script from "./student-location.vue?vue&type=script&lang=js"
export * from "./student-location.vue?vue&type=script&lang=js"
import style0 from "./student-location.vue?vue&type=style&index=0&id=3aea9d52&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports